import {SmartComponent} from "smart-component-js";

class HeaderComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        // Desktop
        const buttons = document.querySelectorAll(".header__megamenu-button");
        const modal = document.querySelector(".header__megamenu-modal");
        const menuContents = document.querySelectorAll(".header__megamenu-content");
        const menuHeaderGreen = document.querySelector(".header__container-green");

        // Mobile
        const burgerMenu = document.getElementById("burgerMenu");
        const modalBurger = document.getElementById("modal");
        const buttonsSubMenu = document.querySelectorAll(".header-burger__submenu-item");

        burgerMenu.addEventListener("click", () => {
            modalBurger.style.display = "flex";
        });

        function closeBurgerModal() {
            modalBurger.style.display = "none";
        }

        function attachCloseEvent() {
            const closeModalButton = document.getElementById("closeModal");
            closeModalButton.addEventListener("click", closeBurgerModal);
        }

        attachCloseEvent();

        buttonsSubMenu.forEach((buttonMobile) => {
            buttonMobile.addEventListener("click", () => {
                const menuMobileId = buttonMobile.getAttribute("data-submenu");
                const contentToShowMobile = document.querySelector(`#mobile-${menuMobileId}`);
                if (contentToShowMobile) {
                    contentToShowMobile.classList.remove("hidden");
                }
            });
        });

        this.attachBackEvent();

        // DESKTOP MODAL

        // Mostra il menu corrispondente
        buttons.forEach((button) => {
            button.addEventListener("mouseenter", () => {
                const menuId = button.getAttribute("data-menu");
                const contentToShow = document.querySelector(`#${menuId}`);

                // Nascondi tutti i contenuti e mostra quello corrispondente
                menuContents.forEach((content) => content.classList.add("hidden"));
                if (contentToShow) {
                    contentToShow.classList.remove("hidden");
                }

                // Mostra il modale
                modal.classList.remove("hidden");
                setTimeout(() =>
                    modal.classList.add("visible"), 60
                )
            });
        });

        // Nasconde il modale quando il mouse esce
        modal.addEventListener("mouseleave", () => {
            setTimeout(() =>
                modal.classList.add("hidden"), 200
            )
            modal.classList.remove("visible");
        });

        menuHeaderGreen.addEventListener("mouseenter", () => {
            setTimeout(() =>
                modal.classList.add("hidden"), 200
            )
            modal.classList.remove("visible");
        });

        // Avvia la gestione delle icone
        this.toggleHiddenForIcons();
    }

    // Aggiungi evento per il pulsante "Indietro"
    attachBackEvent() {
        const backButtons = this.element.querySelectorAll(".header-burger__submenu-back");
        backButtons.forEach((backButton) => {
            backButton.addEventListener("click", () => {
                backButton.closest(".header-burger__submenu-items").classList.add("hidden");
            });
        });
    }

    // Gestione icone
    toggleHiddenForIcons() {
        const icons = document.querySelectorAll(".header__megamenu-icons");
        icons.forEach((icon) => {
            icon.onerror = () => {
                icon.classList.add("hidden");
            };
            icon.onload = () => {
                icon.classList.remove("hidden");
            };

            icon.src = icon.dataset.source
        });
    }

}

export default HeaderComponent;
